import type { Technique } from '../types';
import { POINT_CLOUD_3D_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type PointCloud3dState } from './render';

export const pointCloud3d: Technique<PointCloud3dState> = {
  id: 'point-cloud-3d',
  name: '3D-Punktwolke',
  category: 'dimension',
  description: 'Der Text als Partikelwolke im Raum, mit Tiefenstreuung, Explosion und Tiefenunschärfe.',
  params: POINT_CLOUD_3D_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
